import './HomeBanner.scss';
import { useState } from 'react';
import {Stack, Container, Button, Modal, Form, Row, Col} from 'react-bootstrap';
import { ArrowRight } from 'react-bootstrap-icons';

function CareerBanner({ setactivelink }) {
  return (
    <Stack setactivelink={setactivelink} id="home" gap={6} className="hero-banner">
      <Container>
        <h1 className="career-banner-title">Your Talent. <span className="text-orange">Our Team.</span> Bigger Possibilities</h1>
        <h5 className="my-3">Grow, create, and make an impact with CubeTech Studio.</h5>
      </Container>
    </Stack>
  );
}

export default CareerBanner;